// extracted by mini-css-extract-plugin
module.exports = {"notScrollable":"PlayerCard_notScrollable__1ylKi","playerCard":"PlayerCard_playerCard__jkEbh","portrait":"PlayerCard_portrait__2NDHJ"};